<template>
    <div class="body">
            <p  class="font1" style="padding-top: 8vh;color: #46429e;">卓越进取，成就非凡</p>
            
            <p class="font2" style="padding-top: 2vh;">2025年2月你在富学宝典的学习成就:</p>
            <div>
                <div class="list" v-show="ReportData.coursenumMon">
                    <p class="font2">学习课程<a class="font3">{{ ReportData.coursenumMon }}</a>门</p>
                </div>
                <div class="list" v-show="ReportData.creditvalue">
                    <p class="font2">获得学分<a class="font3">{{ ReportData.creditvalue }}</a>个</p>
                </div>
                <div class="list" v-show="ReportData.examTimes">
                    <p class="font2">累计考试<a class="font3">{{ ReportData.examTimes  }}</a>次</p>
                </div>
                <p v-if="ReportData.rate2" class="font2" style="padding-top: 2vh;">超越了<a class="font3">{{ ReportData.rate2 }}%</a>同行小伙伴！</p>
                <p class="font2" style="padding-top: 2vh;margin: 0;">每一次超越都是对自己极限的突破</p>
                <p class="font2" style="margin: 0;">继续前行，你的潜力无限</p>
            </div>
            

            
    </div>
</template>


<script>
export default {
      props: ["ReportData"],
      data() {
        return {
        }
      },
    }
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/24October/icon.png") 49% calc(100% + 30px) no-repeat,
                url("../../assets/24November/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}
.list{
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 70%;
    /* padding-left: 8%; */
    height: 7vh;
    margin: 0;
    margin-left: 8%;
    background-color: #bab8e8;
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    padding-left: 8%;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #46429e;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.fa{
    color:rgb(206, 144, 28);
    align-items: center;
}
</style>